import { render, staticRenderFns } from "./ProhibidatesComponent.vue?vue&type=template&id=7b22d92c&"
import script from "./ProhibidatesComponent.vue?vue&type=script&lang=js&"
export * from "./ProhibidatesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports